import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ISTDReportsUsercopy_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ISTDReportsUsercopy_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  Logout: boolean;
  Logout_dummy: boolean;
  goToSignInActivity: any;
  goToSignInActivity_dummy: any;
  SelectCustomerWithId: any[];
  SelectCustomerWithId_dummy: any[];
  SelectStationsCountWithId: any[];
  SelectStationsCountWithId_dummy: any[];
  SelectStationsSearchWithId: any[];
  SelectStationsSearchWithId_dummy: any[];
  SelectOrdersCountWithCustomerId: any[];
  SelectOrdersCountWithCustomerId_dummy: any[];
  SelectOrdersWithCustomerId: any[];
  SelectOrdersWithCustomerId_dummy: any[];
  CountForHeaders: any[];
  CountForHeaders_dummy: any[];
  SelectForecastWithCustomerId: any[];
  SelectForecastWithCustomerId_dummy: any[];
  TestChartQuery2: any[];
  TestChartQuery2_dummy: any[];
  ChartQuerySearch: any[];
  ChartQuerySearch_dummy: any[];
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  isComp818740Visible: "visible" | "hidden";
  isComp835553Visible: "visible" | "hidden";
  isComp705224Visible: "visible" | "hidden";
  isComp146609Visible: "visible" | "hidden";
  isComp927916Visible: "visible" | "hidden";
  isComp234126Visible: "visible" | "hidden";
  isComp110612Visible: "visible" | "hidden";
}

export class STDReportsUsercopy_ScreenBase extends React.PureComponent<
  ISTDReportsUsercopy_ScreenProps,
  any
> {
  stdreportsusercopy_521847_value_kuikaTableRef: React.RefObject<any>;
  stdreportsusercopy_892266_value_kuikaTableRef: React.RefObject<any>;
  stdreportsusercopy_700349_value_kuikaTableRef: React.RefObject<any>;
  stdreportsusercopy_979378_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "25c1b361-4262-e567-aef0-4b8ceff8261c",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "ea2af393-7864-0865-c06a-2b07d10d3ec8",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "e0d2e2ac-a738-4799-8aaa-bf93f73ea06a",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 491420, PropertyName: "value", Value: "İstasyon" },
        { Id: 977713, PropertyName: "value", Value: "KLT Sayısı" },
        { Id: 898267, PropertyName: "value", Value: "Siparişler" },
        { Id: 675406, PropertyName: "value", Value: "Tamamlanan Sipariş" },
        { Id: 646225, PropertyName: "value", Value: "İstasyonlar" },
        { Id: 416063, PropertyName: "placeholder", Value: "Search..." },
        { Id: 909895, PropertyName: "title", Value: "İstasyon Adı" },
        { Id: 876167, PropertyName: "value", Value: "[datafield:stationname]" },
        { Id: 594764, PropertyName: "title", Value: "Lokasyon" },
        {
          Id: 620312,
          PropertyName: "value",
          Value: "[datafield:stationlocation]",
        },
        { Id: 106289, PropertyName: "title", Value: "Adres" },
        {
          Id: 779525,
          PropertyName: "value",
          Value: "[datafield:stationaddress]",
        },
        { Id: 26149, PropertyName: "title", Value: "Oluşturulma Tarihi" },
        { Id: 833864, PropertyName: "value", Value: "[datafield:createdat]" },
        { Id: 258376, PropertyName: "title", Value: "Güncellenme Tarihi" },
        { Id: 475243, PropertyName: "value", Value: "[datafield:updatedat]" },
        { Id: 746013, PropertyName: "title", Value: "Durum" },
        { Id: 778698, PropertyName: "value", Value: "Aktif Öngörüler" },
        { Id: 670938, PropertyName: "placeholder", Value: "Search..." },
        { Id: 357822, PropertyName: "title", Value: "İstasyon Adı" },
        { Id: 885753, PropertyName: "value", Value: "[datafield:stationname]" },
        { Id: 80392, PropertyName: "title", Value: "Ürün Kodu" },
        {
          Id: 455275,
          PropertyName: "value",
          Value: "[datafield:customerproductcode]",
        },
        { Id: 846935, PropertyName: "title", Value: "Öngörülen Adet" },
        {
          Id: 651211,
          PropertyName: "value",
          Value: "[datafield:forecastquantity]",
        },
        { Id: 419062, PropertyName: "title", Value: "Tamamlanan Adet" },
        {
          Id: 923810,
          PropertyName: "value",
          Value: "[datafield:totalorderedquantity]",
        },
        { Id: 773324, PropertyName: "title", Value: "Tamamlanma Oranı" },
        {
          Id: 555170,
          PropertyName: "value",
          Value: "[datafield:completionpercentage]",
        },
        { Id: 489460, PropertyName: "value", Value: "Aktif Öngörüler" },
        { Id: 230803, PropertyName: "title", Value: "İstasyon Adı" },
        { Id: 868501, PropertyName: "value", Value: "[datafield:stationname]" },
        { Id: 710533, PropertyName: "title", Value: "Ürün Kodu" },
        {
          Id: 18532,
          PropertyName: "value",
          Value: "[datafield:customerproductcode]",
        },
        { Id: 767446, PropertyName: "title", Value: "Öngörülen Adet" },
        {
          Id: 173260,
          PropertyName: "value",
          Value: "[datafield:forecastquantity]",
        },
        { Id: 88421, PropertyName: "title", Value: "Tamamlanan Adet" },
        {
          Id: 889797,
          PropertyName: "value",
          Value: "[datafield:totalorderedquantity]",
        },
        { Id: 862253, PropertyName: "title", Value: "Tamamlanma Oranı" },
        {
          Id: 172335,
          PropertyName: "value",
          Value: "[datafield:completionpercentage]",
        },
        { Id: 712759, PropertyName: "value", Value: "Öngörülen Adet" },
        { Id: 289646, PropertyName: "value", Value: "Tamamlanan Adet" },
        { Id: 849291, PropertyName: "value", Value: "Siparişler" },
        { Id: 320045, PropertyName: "placeholder", Value: "Search..." },
        { Id: 375206, PropertyName: "value", Value: "Malzeme Kodu" },
        { Id: 259590, PropertyName: "value", Value: "STenco Malzeme Kodu" },
        { Id: 208933, PropertyName: "value", Value: "STenco Malzeme Tanımı" },
        { Id: 201141, PropertyName: "value", Value: "Kutu içi Adet" },
        { Id: 72424, PropertyName: "value", Value: "İstasyon Adı" },
        { Id: 216132, PropertyName: "value", Value: "Oluşturma Tarihi" },
        { Id: 369042, PropertyName: "value", Value: "Sipariş No" },
        { Id: 429380, PropertyName: "value", Value: "Sipariş Durum" },
        {
          Id: 36473,
          PropertyName: "value",
          Value: "[datafield:customerproductcode]",
        },
        { Id: 54670, PropertyName: "value", Value: "[datafield:productcode]" },
        { Id: 545650, PropertyName: "value", Value: "[datafield:productname]" },
        {
          Id: 830161,
          PropertyName: "value",
          Value: "[datafield:expectedquantity]",
        },
        { Id: 755432, PropertyName: "value", Value: "[datafield:stationname]" },
        { Id: 56346, PropertyName: "value", Value: "[datafield:createdate]" },
        { Id: 158852, PropertyName: "value", Value: "[datafield:saporderid]" },
        { Id: 146609, PropertyName: "value", Value: "Kısmi Tamamlandı" },
        { Id: 927916, PropertyName: "value", Value: "Bekliyor" },
        { Id: 234126, PropertyName: "value", Value: "Tamamlandı" },
        { Id: 110612, PropertyName: "value", Value: "Tamamlanmadı" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.stdreportsusercopy_416063_value_kuikaTextInputRef = React.createRef();
    this.stdreportsusercopy_521847_value_kuikaTableRef = React.createRef();
    this.stdreportsusercopy_670938_value_kuikaTextInputRef = React.createRef();
    this.stdreportsusercopy_892266_value_kuikaTableRef = React.createRef();
    this.stdreportsusercopy_700349_value_kuikaTableRef = React.createRef();
    this.stdreportsusercopy_320045_value_kuikaTextInputRef = React.createRef();
    this.stdreportsusercopy_979378_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      Logout: false,
      goToSignInActivity: "",
      SelectCustomerWithId: [],
      SelectStationsCountWithId: [],
      SelectStationsSearchWithId: [],
      SelectOrdersCountWithCustomerId: [],
      SelectOrdersWithCustomerId: [],
      CountForHeaders: [],
      SelectForecastWithCustomerId: [],
      TestChartQuery2: [],
      ChartQuerySearch: [],
      NAVIGATE: "",
      isComp818740Visible: "hidden",
      isComp835553Visible: "hidden",
      isComp705224Visible: "hidden",
      isComp146609Visible: "hidden",
      isComp927916Visible: "hidden",
      isComp234126Visible: "hidden",
      isComp110612Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("stdreportsusercopy", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    if (true) {
      await this.STDReportsUsercopyPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("stdreportsusercopy", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("stdreportsusercopy", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.STDReportsUsercopyPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      stdreportsusercopy_818740_value:
        this.state.SelectCustomerWithId?.at?.(0)?.customerLogo ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  STDReportsUsercopyPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
      searchFor_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsusercopy_416063_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
      searchFor_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsusercopy_416063_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerId_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
      searchFor_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsusercopy_320045_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerId_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
      searchFor_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsusercopy_320045_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerId_4: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
      CustomerId_5: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
      CustomerId_6: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
      CustomerId_7: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
      CustomerProductCode_7: ReactSystemFunctions.convertToTypeByName(
        null,
        "string"
      ),
      CustomerId_8: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
      searchFor_8: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsusercopy_670938_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDReportsUsercopy/STDReportsUsercopyPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SelectCustomerWithId = result?.data.selectCustomerWithId;
    formVars.stdreportsusercopy_818740_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectCustomerWithId !== undefined
        ? stateVars.SelectCustomerWithId?.length > 0
          ? stateVars.SelectCustomerWithId[0].customerLogo
          : null
        : this.state.SelectCustomerWithId?.length > 0
        ? this.state.SelectCustomerWithId[0].customerLogo
        : null
    );
    formVars.stdreportsusercopy_818740_placeholderimage = "";
    formVars.stdreportsusercopy_982360_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectCustomerWithId !== undefined
        ? stateVars.SelectCustomerWithId?.length > 0
          ? stateVars.SelectCustomerWithId[0].name
          : null
        : this.state.SelectCustomerWithId?.length > 0
        ? this.state.SelectCustomerWithId[0].name
        : null
    );
    stateVars.isComp818740Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectCustomerWithId !== undefined
            ? stateVars.SelectCustomerWithId?.length > 0
              ? stateVars.SelectCustomerWithId[0].customerLogo
              : null
            : this.state.SelectCustomerWithId?.length > 0
            ? this.state.SelectCustomerWithId[0].customerLogo
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.SelectStationsCountWithId =
      result?.data.selectStationsCountWithId;
    stateVars.SelectStationsSearchWithId =
      result?.data.selectStationsSearchWithId;

    stateVars.SelectOrdersCountWithCustomerId =
      result?.data.selectOrdersCountWithCustomerId;
    stateVars.SelectOrdersWithCustomerId =
      result?.data.selectOrdersWithCustomerId;

    stateVars.CountForHeaders = result?.data.countForHeaders;
    formVars.stdreportsusercopy_38980_value = ReactSystemFunctions.toString(
      this,
      stateVars.CountForHeaders !== undefined
        ? stateVars.CountForHeaders?.length > 0
          ? stateVars.CountForHeaders[0].stationCount
          : null
        : this.state.CountForHeaders?.length > 0
        ? this.state.CountForHeaders[0].stationCount
        : null
    );
    formVars.stdreportsusercopy_101411_value = ReactSystemFunctions.toString(
      this,
      stateVars.CountForHeaders !== undefined
        ? stateVars.CountForHeaders?.length > 0
          ? stateVars.CountForHeaders[0].boxCount
          : null
        : this.state.CountForHeaders?.length > 0
        ? this.state.CountForHeaders[0].boxCount
        : null
    );
    formVars.stdreportsusercopy_890896_value = ReactSystemFunctions.toString(
      this,
      stateVars.CountForHeaders !== undefined
        ? stateVars.CountForHeaders?.length > 0
          ? stateVars.CountForHeaders[0].orderCount
          : null
        : this.state.CountForHeaders?.length > 0
        ? this.state.CountForHeaders[0].orderCount
        : null
    );
    formVars.stdreportsusercopy_712246_value = ReactSystemFunctions.toString(
      this,
      stateVars.CountForHeaders !== undefined
        ? stateVars.CountForHeaders?.length > 0
          ? stateVars.CountForHeaders[0].completedOrderCount
          : null
        : this.state.CountForHeaders?.length > 0
        ? this.state.CountForHeaders[0].completedOrderCount
        : null
    );
    stateVars.SelectForecastWithCustomerId =
      result?.data.selectForecastWithCustomerId;
    stateVars.TestChartQuery2 = result?.data.testChartQuery2;

    stateVars.ChartQuerySearch = result?.data.chartQuerySearch;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDReportsUsercopyPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDReportsUsercopyPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.stdreportsusercopy_818740_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectCustomerWithId !== undefined
        ? stateVars.SelectCustomerWithId?.length > 0
          ? stateVars.SelectCustomerWithId[0].customerLogo
          : null
        : this.state.SelectCustomerWithId?.length > 0
        ? this.state.SelectCustomerWithId[0].customerLogo
        : null
    );

    stateVars.isComp818740Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectCustomerWithId !== undefined
            ? stateVars.SelectCustomerWithId?.length > 0
              ? stateVars.SelectCustomerWithId[0].customerLogo
              : null
            : this.state.SelectCustomerWithId?.length > 0
            ? this.state.SelectCustomerWithId[0].customerLogo
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.stdreportsusercopy_982360_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectCustomerWithId !== undefined
        ? stateVars.SelectCustomerWithId?.length > 0
          ? stateVars.SelectCustomerWithId[0].name
          : null
        : this.state.SelectCustomerWithId?.length > 0
        ? this.state.SelectCustomerWithId[0].name
        : null
    );

    formVars.stdreportsusercopy_38980_value = ReactSystemFunctions.toString(
      this,
      stateVars.CountForHeaders !== undefined
        ? stateVars.CountForHeaders?.length > 0
          ? stateVars.CountForHeaders[0].stationCount
          : null
        : this.state.CountForHeaders?.length > 0
        ? this.state.CountForHeaders[0].stationCount
        : null
    );

    formVars.stdreportsusercopy_101411_value = ReactSystemFunctions.toString(
      this,
      stateVars.CountForHeaders !== undefined
        ? stateVars.CountForHeaders?.length > 0
          ? stateVars.CountForHeaders[0].boxCount
          : null
        : this.state.CountForHeaders?.length > 0
        ? this.state.CountForHeaders[0].boxCount
        : null
    );

    formVars.stdreportsusercopy_890896_value = ReactSystemFunctions.toString(
      this,
      stateVars.CountForHeaders !== undefined
        ? stateVars.CountForHeaders?.length > 0
          ? stateVars.CountForHeaders[0].orderCount
          : null
        : this.state.CountForHeaders?.length > 0
        ? this.state.CountForHeaders[0].orderCount
        : null
    );

    formVars.stdreportsusercopy_712246_value = ReactSystemFunctions.toString(
      this,
      stateVars.CountForHeaders !== undefined
        ? stateVars.CountForHeaders?.length > 0
          ? stateVars.CountForHeaders[0].completedOrderCount
          : null
        : this.state.CountForHeaders?.length > 0
        ? this.state.CountForHeaders[0].completedOrderCount
        : null
    );

    stateVars.dataSource_521847 =
      stateVars.SelectStationsSearchWithId ??
      this.state.SelectStationsSearchWithId;
    stateVars.isComp835553Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "stdreportsusercopy_521847_value",
          "stationStatus"
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp705224Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "stdreportsusercopy_521847_value",
          "stationStatus"
        ),
        false
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_892266 =
      stateVars.ChartQuerySearch ?? this.state.ChartQuerySearch;

    stateVars.dataSource_700349 =
      stateVars.ChartQuerySearch ?? this.state.ChartQuerySearch;

    stateVars.dataSource_513570 =
      stateVars.TestChartQuery2 ?? this.state.TestChartQuery2;

    stateVars.dataSource_979378 =
      stateVars.SelectOrdersWithCustomerId ??
      this.state.SelectOrdersWithCustomerId;
    stateVars.isComp146609Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "stdreportsusercopy_979378_value",
          "orderStatus"
        ),
        ReactSystemFunctions.convertToTypeByName("4", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp927916Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "stdreportsusercopy_979378_value",
          "orderStatus"
        ),
        ReactSystemFunctions.convertToTypeByName("2", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp234126Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "stdreportsusercopy_979378_value",
          "orderStatus"
        ),
        ReactSystemFunctions.convertToTypeByName("3", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp110612Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "stdreportsusercopy_979378_value",
          "orderStatus"
        ),
        ReactSystemFunctions.convertToTypeByName("5", "string")
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  STDReportsUsercopyComponent_981633_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.Logout = await ReactSystemFunctions.logout();
    stateVars.tmpBoolResult = await ReactSystemFunctions.goToSignInActivity(
      this
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDReportsUsercopyComponent_416063_onPressEnter = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      searchFor_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsusercopy_416063_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
      searchFor_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsusercopy_416063_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDReportsUsercopy/STDReportsUsercopyComponent_416063_onPressEnter",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SelectStationsCountWithId =
      result?.data.selectStationsCountWithId;
    stateVars.SelectStationsSearchWithId =
      result?.data.selectStationsSearchWithId;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDReportsUsercopyComponent_416063_onPressEnter1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDReportsUsercopyComponent_416063_onPressEnter1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_521847 =
      stateVars.SelectStationsSearchWithId ??
      this.state.SelectStationsSearchWithId;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDReportsUsercopyComponent_416063_onBlur = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      searchFor_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsusercopy_416063_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
      searchFor_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsusercopy_416063_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDReportsUsercopy/STDReportsUsercopyComponent_416063_onBlur",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SelectStationsCountWithId =
      result?.data.selectStationsCountWithId;
    stateVars.SelectStationsSearchWithId =
      result?.data.selectStationsSearchWithId;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDReportsUsercopyComponent_416063_onBlur1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDReportsUsercopyComponent_416063_onBlur1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_521847 =
      stateVars.SelectStationsSearchWithId ??
      this.state.SelectStationsSearchWithId;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDReportsUsercopyComponent_670938_onPressEnter = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
      searchFor_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsusercopy_670938_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
      CustomerProductCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsusercopy_670938_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDReportsUsercopy/STDReportsUsercopyComponent_670938_onPressEnter",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ChartQuerySearch = result?.data.chartQuerySearch;

    stateVars.TestChartQuery2 = result?.data.testChartQuery2;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDReportsUsercopyComponent_670938_onPressEnter1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDReportsUsercopyComponent_670938_onPressEnter1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_892266 =
      stateVars.ChartQuerySearch ?? this.state.ChartQuerySearch;

    stateVars.dataSource_700349 =
      stateVars.ChartQuerySearch ?? this.state.ChartQuerySearch;

    stateVars.dataSource_513570 =
      stateVars.TestChartQuery2 ?? this.state.TestChartQuery2;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDReportsUsercopyComponent_320045_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      searchFor_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdreportsusercopy_320045_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerId ??
          this.props.screenInputs.customerid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDReportsUsercopy/STDReportsUsercopyComponent_320045_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SelectOrdersWithCustomerId =
      result?.data.selectOrdersWithCustomerId;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDReportsUsercopyComponent_320045_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDReportsUsercopyComponent_320045_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_979378 =
      stateVars.SelectOrdersWithCustomerId ??
      this.state.SelectOrdersWithCustomerId;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDReportsUsercopyComponent_146609_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "BoxLogs",
      "BoxId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "stdreportsusercopy_979378_value",
          "boxId"
        ),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "STDReportsUsercopy",
      "BoxLogs",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "855922",
      null,
      "right",
      "true",
      "500px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDReportsUsercopyComponent_927916_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "BoxLogs",
      "BoxId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "stdreportsusercopy_979378_value",
          "boxId"
        ),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "STDReportsUsercopy",
      "BoxLogs",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "461938",
      null,
      "right",
      "true",
      "500px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDReportsUsercopyComponent_234126_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "BoxLogs",
      "BoxId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "stdreportsusercopy_979378_value",
          "boxId"
        ),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "STDReportsUsercopy",
      "BoxLogs",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "642027",
      null,
      "right",
      "true",
      "500px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDReportsUsercopyComponent_110612_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "BoxLogs",
      "BoxId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "stdreportsusercopy_979378_value",
          "boxId"
        ),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "STDReportsUsercopy",
      "BoxLogs",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "544454",
      null,
      "right",
      "true",
      "500px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [855922, 461938, 642027, 544454] as number[];
    if (
      isFromMaster ||
      ((window.kuika?.disableSmartExecutePageInit?.["STDReportsUsercopy"] ??
        false) &&
        pageInitCallerNavDiIDs.indexOf(diId) > -1)
    ) {
      await this.STDReportsUsercopyPageInit();
    } else if (
      window.kuika?.serverRequestCount > 0 &&
      pageInitCallerNavDiIDs.indexOf(diId) > -1
    ) {
      await this.STDReportsUsercopyPageInit();
    }
  }
}
